import { Button, FormControl, TextField } from "@mui/material"
import { t } from "i18next"
import { JSX, type PropsWithChildren } from "react"

import { Stack } from "@/generated/material"

import { LOGIN_LOCATORS } from "./locators"
import { useLoginForm } from "./useLoginForm"

interface Props {
  buttonWrapper?: (props: PropsWithChildren) => JSX.Element
}

const InputProps = {
  sx: {
    backgroundColor: "transparent",
  },
}

export const LoginForm = ({ buttonWrapper }: Props) => {
  const {
    email,
    errorMessage,
    emailInputRef,
    loading,
    isDisconnected,
    canSubmit,
    handleEmailChange,
    handleSubmit,
  } = useLoginForm()

  const ButtonWrapper = buttonWrapper ?? Stack

  return (
    <FormControl
      component="form"
      onSubmit={handleSubmit}
      noValidate // inline isValidEmail is the single source of truth, not the browser's native bubble
      aria-busy={loading}
      error={isDisconnected}
      sx={{ maxWidth: "350px", width: "350px", gap: 4 }}
    >
      <TextField
        label={t("login.email")}
        type="email"
        autoComplete="email"
        name="email"
        value={email}
        onChange={handleEmailChange}
        inputRef={emailInputRef}
        data-testid={LOGIN_LOCATORS.emailInput}
        slotProps={{ input: InputProps, formHelperText: { role: "alert" } }}
        error={!!errorMessage}
        helperText={errorMessage || " "} // keeps the alert region mounted so changes are announced to the screen reader
      />

      <ButtonWrapper sx={{ paddingBlockStart: 1 }}>
        <Button
          data-testid={LOGIN_LOCATORS.loginButton}
          type="submit"
          loading={loading}
          variant="contained"
          sx={{ width: "100%" }}
          disabled={!canSubmit}
        >
          {t("login.loginButton")}
        </Button>
      </ButtonWrapper>
    </FormControl>
  )
}
